/**
 * Display high results.
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function ResultHigh({ highResults, introText, title }) {
  const showResults = (highResults.length > 0);
  return (
    <span>
      {showResults &&
        <div>
          <h2>
            {title}
          </h2>
          <div
            dangerouslySetInnerHTML={{
              __html: introText,
            }}
          />
          <div
            className={classnames({
              'results--high': true,
            })}
          >
            {highResults}
          </div>
        </div>
      }
    </span>
  );
}

ResultHigh.propTypes = {
  highResults: PropTypes.arrayOf(PropTypes.shape({})),
  introText: PropTypes.string,
  title: PropTypes.string,
};

export default ResultHigh;



// WEBPACK FOOTER //
// js/src/assessment/ResultHigh.js